import { createSlice } from "@reduxjs/toolkit";
import ls from "localstorage-slim";

export const SUBSCRIPTION_PLANS = {
  FREE: "FREE",
  PREMIUM: "PREMIUM",
  PLATINUM: "PLATINUM",
};

export const FREE_PLAN_ROUTES = [
  "/dashboard",
  "/employee",
  "/event",
  "/leave-task",
  "/settings",
  "/help",
  "/company-profile",
  "/notification",
  "/subscription",
];

export const isFreePlanRoute = (path) => {
  return FREE_PLAN_ROUTES.some((route) => path.startsWith(route));
};

export const SUBSCRIPTION_ROUTE_ACCESS = {
  FREE: FREE_PLAN_ROUTES,
  PREMIUM: [...FREE_PLAN_ROUTES, "/attendance"],
  PLATINUM: ["*"],
};

const initialState = {
  plan:
    ls.get("subscriptionPlan", { decrypt: true }) || SUBSCRIPTION_PLANS.FREE,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setSubscriptionPlan(state, action) {
      const plan = action.payload;
      state.plan = plan;
      ls.set("subscriptionPlan", plan, { decrypt: true });
    },
  },
});

export const subscriptionActions = subscriptionSlice.actions;

export const subscriptionSelectors = {
  selectCurrentPlan: (state) => state.subscription.plan,

  canAccessRoute: (state, route) => {
    const currentPlan = state.subscription.plan;

    if (isFreePlanRoute(route)) {
      return true;
    }

    // Platinum can access everything
    if (currentPlan === SUBSCRIPTION_PLANS.PLATINUM) {
      return true;
    }

    // For PREMIUM plan, check if the route is in the allowed list
    if (currentPlan === SUBSCRIPTION_PLANS.PREMIUM) {
      const allowedRoutes =
        SUBSCRIPTION_ROUTE_ACCESS[SUBSCRIPTION_PLANS.PREMIUM];

      return allowedRoutes.some((allowedRoute) => {
        if (allowedRoute.endsWith("*")) {
          const prefix = allowedRoute.slice(0, -1);
          return route.startsWith(prefix);
        }
        return route.startsWith(allowedRoute);
      });
    }

    return false;
  },
};

export default subscriptionSlice.reducer;
